import * as React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { prefetchImages } from '../../../constants/prefetchImages';
import { dateHandler } from '../../../helpers/date/dateHandler';
import ClientFooterContent from './client/ClientFooterContent';
import './Footer.css';
import PrefetchContent from './PrefetchContent';

const Footer: React.FunctionComponent<any> = () => {

  return (
    <Container fluid={true}>
      <Col xs="12" className="Footer">
        <Row>
          <Col xs={{ size: 10, offset: 1 }}>
            <Row>
              <Col xs="4">
                <span className="loginDate">Last updated: {dateHandler.getCurrentDateTime()}</span>
              </Col>
              <Col xs="8">
                <ClientFooterContent />
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>
      {prefetchImages.map((img, i)=>{
        return <PrefetchContent key={i} url={process.env.PUBLIC_URL+img} />
      })}
    </Container>
  );
};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/shared/footer/Footer.tsx